import PropTypes from 'prop-types';
import { useTranslation } from 'react-i18next';
import { Menu } from 'antd';
import { useNavMenuState } from './useNavMenuState';
import { getNavMenuItems } from './getNavMenuItems';

const defaultMenuStyle = {
  padding: '16px 0'
};

const NavMenu = ({
  setCollapsed,
  routes,
  subRoutes,
  pathSearches,
  menuStyle,
  groups
}) => {
  const { t } = useTranslation();
  const { path, activeKeys, width } = useNavMenuState();

  const items = getNavMenuItems(routes, subRoutes, pathSearches, path, t);
  const groupedItems = groups
    ? groups.map(({ key, routes: groupRoutes }) => ({
        type: 'group',
        key: `group-${key}`,
        label: t(`basiclayout.menu.groups.${key}`),
        children: items.filter((item) =>
          groupRoutes.some((route) => routes[route] === item.key)
        )
      }))
    : items;

  return (
    <Menu
      style={{ ...defaultMenuStyle, ...menuStyle }}
      selectedKeys={activeKeys}
      defaultOpenKeys={width < 992 ? [] : activeKeys}
      mode="inline"
      onSelect={width < 992 ? () => setCollapsed(true) : () => {}}
      items={groupedItems}
    />
  );
};

NavMenu.propTypes = {
  setCollapsed: PropTypes.func.isRequired,
  routes: PropTypes.shape({}).isRequired,
  subRoutes: PropTypes.shape({}).isRequired,
  pathSearches: PropTypes.shape({}).isRequired,
  menuStyle: PropTypes.shape({}),
  groups: PropTypes.arrayOf(
    PropTypes.shape({
      key: PropTypes.string.isRequired,
      routes: PropTypes.arrayOf(PropTypes.string).isRequired
    })
  )
};

NavMenu.defaultProps = {
  menuStyle: undefined,
  groups: undefined
};

export default NavMenu;
